import React, { useState } from "react";
import { Box, Paper, TextField, Button, Typography, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { changeMyPassword } from "../api";

export default function ChangePassword() {
  const { mustChange, refresh } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (next.length < 4) { setError("New password must be at least 4 characters."); return; }
    if (next !== confirm) { setError("New passwords do not match."); return; }
    setBusy(true);
    try {
      await changeMyPassword(current, next);
      await refresh();
      nav("/events", { replace: true });
    } catch (err: any) {
      setError(err?.message || "Could not change password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", bgcolor: "background.default", color: "text.primary" }}>
      <Paper component="form" onSubmit={submit} sx={{ p: 4, width: 380, maxWidth: "90vw" }}>
        <Typography variant="h5" sx={{ mb: 0.5 }}>Change password</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {mustChange ? "Your account uses a temporary password. Set a new one to continue." : "Update your account password."}
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField label="Current password" type="password" fullWidth value={current}
          onChange={(e) => setCurrent(e.target.value)} sx={{ mb: 2 }} autoFocus autoComplete="current-password" />
        <TextField label="New password" type="password" fullWidth value={next}
          onChange={(e) => setNext(e.target.value)} sx={{ mb: 2 }} autoComplete="new-password" />
        <TextField label="Confirm new password" type="password" fullWidth value={confirm}
          onChange={(e) => setConfirm(e.target.value)} sx={{ mb: 3 }} autoComplete="new-password" />
        <Button type="submit" variant="contained" fullWidth disabled={busy || !current || !next || !confirm}>
          {busy ? "Saving…" : "Set new password"}
        </Button>
      </Paper>
    </Box>
  );
}
